import { addWeeks } from 'date-fns';
import { useMemo } from 'react';
import { isBetween } from 'shared/lib/date-fns';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { getOccurrences } from 'shared/utils/schedules';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export const useTimeframeOccurrences = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) => {
  // get a bigger range for extra completions to display in the month-view
  const rangeStartDate = useMemo(() => addWeeks(startDate, -3), [startDate]);
  const rangeEndDate = useMemo(() => addWeeks(endDate, 3), [endDate]);

  const occurrences = useMemo(
    () =>
      getOccurrences(schedules, {
        startDate: rangeStartDate,
        endDate: rangeEndDate,
      }),
    [rangeEndDate, rangeStartDate, schedules],
  );

  const timeframeOccurrences = useMemo(
    () =>
      occurrences.filter((occurrence) =>
        isBetween(occurrence, startDate, endDate),
      ),
    [endDate, occurrences, startDate],
  );

  return {
    occurrences,
    timeframeOccurrences,
  };
};
